import {
  ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN_SUCCESS,
  ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN_FAILED,
  RESET_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN,
  LOADING_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN,
  NETWORK_ERROR_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAddOrUpdateBusinessNatureSubCategoryAdmin = () => {
  return { type: RESET_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN };
};

const adminAddOrUpdateBusinessNatureSubCategoryAdmin =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN });
    await adminServices
      .post("addOrUpdateBusinessNatureSubCategory", userData, {
        headers: { AuthToken: authTokenIs },
      })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(adminAddOrUpdateCurrencysuccess(res.data));
            break;
          default:
            dispatch(adminAddOrUpdateCurrencyFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN,
          payload: err,
        });
      });
  };
function adminAddOrUpdateCurrencysuccess(data) {
  return {
    type: ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN_SUCCESS,
    payload: data,
  };
}
function adminAddOrUpdateCurrencyFailed(data) {
  return {
    type: ADDORUPDATEBUSINESSNATURESUBCATEGORYADMIN_FAILED,
    payload: data,
  };
}

export {
  resetAddOrUpdateBusinessNatureSubCategoryAdmin,
  adminAddOrUpdateBusinessNatureSubCategoryAdmin,
};
